import { MutationTree } from 'vuex';
import Location from '@/location/Location';
import LocationState from '@/store/modules/locations/LocationState';

const mutations: MutationTree<LocationState> = {
    setLocations(state, locations: object): void {
        Location.create({
            data: locations,
        });
    },
    setActiveLocationPanelItem(state, id: string): void {
        state.activeLocationPanelItem = id;
    },
    toggleMobileMenu(state, open?: boolean): void {
        state.mobileMenuOpened = open === undefined ? !state.mobileMenuOpened : open;
    },
};

export default mutations;
